import {
  // Common actions
  UPDATE_TEAM_FILTER,
  UPDATE_IS_RECEIVING_FEEDBACK_ERROR,

  // Filter actions
  UPDATE_SEARCH_TEXT,
  UPDATE_APPLIED_FILTERS,
  UPDATE_FILTER_KEYS,
  UPDATE_GROUP_BY,
  UPDATE_PAGINATION,

  // Flag actions
  UPDATE_STATS_IS_DATA_LOADED,
  UPDATE_STATS_IS_LOADING,
  UPDATE_STATS_IS_BACKGROUND_LOADING,
  UPDATE_TABLE_IS_DATA_LOADED,
  UPDATE_TABLE_IS_LOADING,
  UPDATE_TABLE_IS_BACKGROUND_LOADING,

  // Stats data actions
  UPDATE_STATS_DATA,
  UPDATE_STATS_RAW_DATA,

  // Table data actions
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_COLUMNS,
  UPDATE_TABLE_RAW_DATA,

  // Reset actions
  RESET_RECEIVING_FEEDBACK_DATA,
  RESET_STATS_DATA,
  RESET_TABLE_DATA,
} from "./action";

const initialState = {
  // Common
  teamFilter: "entire_team", // Default team filter
  isError: false,

  // Filters
  searchText: "",
  appliedFilters: [],
  filterKeys: null,
  groupBy: "department",
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },

  // Stats section
  stats: {
    isDataLoaded: false,
    isLoading: false,
    isBackgroundLoading: false,
    data: null,
    rawData: null,
  },

  // Table section
  table: {
    isDataLoaded: false,
    isLoading: false,
    isBackgroundLoading: false,
    data: null,
    columns: null,
    rawData: null,
  },
};

const receivingFeedback = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TEAM_FILTER: {
      const { teamFilter } = action.payload;
      return {
        ...state,
        teamFilter,
      };
    }

    case UPDATE_IS_RECEIVING_FEEDBACK_ERROR: {
      const { isError } = action.payload;
      return {
        ...state,
        isError,
      };
    }

    // Filter actions
    case UPDATE_SEARCH_TEXT: {
      const { searchText } = action.payload;
      return {
        ...state,
        searchText,
      };
    }

    case UPDATE_APPLIED_FILTERS: {
      const { appliedFilters } = action.payload;
      return {
        ...state,
        appliedFilters,
      };
    }

    case UPDATE_FILTER_KEYS: {
      const { filterKeys } = action.payload;
      return {
        ...state,
        filterKeys,
      };
    }

    case UPDATE_GROUP_BY: {
      const { groupBy } = action.payload;
      return {
        ...state,
        groupBy,
      };
    }

    case UPDATE_PAGINATION: {
      const { pagination } = action.payload;
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...pagination,
        },
      };
    }

    // Stats flag actions
    case UPDATE_STATS_IS_DATA_LOADED: {
      const { isDataLoaded } = action.payload;
      return {
        ...state,
        stats: {
          ...state.stats,
          isDataLoaded,
        },
      };
    }

    case UPDATE_STATS_IS_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        stats: {
          ...state.stats,
          isLoading,
        },
      };
    }

    case UPDATE_STATS_IS_BACKGROUND_LOADING: {
      const { isBackgroundLoading } = action.payload;
      return {
        ...state,
        stats: {
          ...state.stats,
          isBackgroundLoading,
        },
      };
    }

    // Table flag actions
    case UPDATE_TABLE_IS_DATA_LOADED: {
      const { isDataLoaded } = action.payload;
      return {
        ...state,
        table: {
          ...state.table,
          isDataLoaded,
        },
      };
    }

    case UPDATE_TABLE_IS_LOADING: {
      const { isLoading } = action.payload;
      return {
        ...state,
        table: {
          ...state.table,
          isLoading,
        },
      };
    }

    case UPDATE_TABLE_IS_BACKGROUND_LOADING: {
      const { isBackgroundLoading } = action.payload;
      return {
        ...state,
        table: {
          ...state.table,
          isBackgroundLoading,
        },
      };
    }

    // Stats data actions
    case UPDATE_STATS_DATA: {
      const { data } = action.payload;
      return {
        ...state,
        stats: {
          ...state.stats,
          data,
        },
      };
    }

    case UPDATE_STATS_RAW_DATA: {
      const { rawData } = action.payload;
      return {
        ...state,
        stats: {
          ...state.stats,
          rawData,
        },
      };
    }

    // Table data actions
    case UPDATE_TABLE_DATA: {
      const { data } = action.payload;
      return {
        ...state,
        table: {
          ...state.table,
          data,
        },
      };
    }

    case UPDATE_TABLE_COLUMNS: {
      const { columns } = action.payload;
      return {
        ...state,
        table: {
          ...state.table,
          columns,
        },
      };
    }

    case UPDATE_TABLE_RAW_DATA: {
      const { rawData } = action.payload;
      return {
        ...state,
        table: {
          ...state.table,
          rawData,
        },
      };
    }

    // Reset actions
    case RESET_RECEIVING_FEEDBACK_DATA: {
      return {
        ...initialState,
      };
    }

    case RESET_STATS_DATA: {
      return {
        ...state,
        stats: {
          ...initialState.stats,
        },
      };
    }

    case RESET_TABLE_DATA: {
      return {
        ...state,
        table: {
          ...initialState.table,
        },
      };
    }

    default:
      return state;
  }
};

export default receivingFeedback;
